import { GroupChatsSectionsService } from './group-chats-sections.service';

export { GroupChatsSectionsService };

export default [GroupChatsSectionsService];
